<template>
    <div class="" style="">
        <div class="topImgContent">
            <div class="topImgTitleContent">
            <div class="topImgTitle">我的诉求</div>
            <div class="topImgsubTitle">FUTURE SCIENCE CITY NEWS</div>
            <div class="e-flex menuContent">
                <img class="ic_home" src="@/assets/images/ic_home.png">
                <div class="pointer" @click="goMainPage()">首页</div>
                <div>/</div>
                <div class="pointer" @click="$router.push({ path: (from && from == 1) ? '/index/index' : '/appeal/index', query: {}})">我的诉求</div>
                <div>/</div>
                <div>详情</div>
                </div>
            </div>
        </div>
        <div class="e-flex ad_detailContentAll">
            <div class="ad_detailContent">
                <div class="ad_detailTopContent">
                    <div class="ad_detaiTitle e-line-1">企业人才诉求表单</div>
                    <div class="ad_detaiDate e-line-1">提交时间：{{ info.createDate.slice(0,16) }}</div>
                </div>
                <div class="ad_detailInfoContent">
                    <div class="e-flex ad_detailTopTwo">
                        <div class="ad_detailLabel">企业名称：</div>
                        <div class="ad_detailValue  e-line-1">{{info.company}}</div>
                    </div>
                    <div class="e-flex ad_detailTopTwo">
                        <div class="ad_detailLabel">企业地址：</div>
                        <div class="ad_detailValue  e-line-1">{{ info.address }}</div>
                    </div>
                    <div class="e-flex ad_detailTopTwo">
                        <div class="ad_detailLabel">联系人：</div>
                        <div class="ad_detailValue2">{{ info.contact }}</div>
                        <div class="ad_detailLabel">联系方式：</div>
                        <div class="ad_detailValue2">{{ info.phone }}</div>
                    </div>
                    <div class="ad_detailTopTwo">
                        <div class="ad_detailLabel">诉求事项：</div>
                        <div class="ad_detailValue">{{ info.content }}</div>
                    </div>
                    <div class="ad_detailTopTwo">
                        <div class="ad_detailLabel">意见建议：</div>
                        <div class="ad_detailValue">{{ info.feed }}</div>
                    </div>
                </div>
                
            </div>
        </div>
        <div class="e-flex ad_detailContentAll" v-if="info.reply">
            <div class="ad_detailReplayContent">
                <div class="ad_replayTitle">回复消息：</div>
                <div class="ad_replayContent">{{ info.reply }}</div>
            </div>
        </div>
        <div class="ad_bottom"></div>
      
    </div>
  </template>
  
  <script>
    import '../../styles/appeal.css'
    export default {
      name: 'appealDetail',
      data () {
        return {
          from: '',
          id: '',
          info: {}
        }
      },
      created() {
        this.from = this.$route.query.from
        this.id = this.$route.query.id
        this.getDetail()
      },
      methods: {
        goMainPage() {
          this.$emit('goNavPage', {
            key:'1',
            path: ['1'],
            pathId: '1'
          })
        },
        getDetail() {
          this.request({
              url: 'feedback/detail',
              method: 'POST',
              data: {
                id: this.id
              }
            }).then(res => {
                if (res.code == 1) {
                  this.info = res.data
                } else {
                    this.$message({
                        message: res.msg,
                        type: 'error'
                    });
                }
            })
        }
      }
    }
  </script>
  
  <!-- Add "scoped" attribute to limit CSS to this component only -->
  <style scoped>
  
  </style>
  


// WEBPACK FOOTER //
// src/view/appeal/appealDetail.vue